module.exports = __webpack_public_path__ + "static/metal_scanner_0-a0f00f4556abb61be7f4d9a1c6af1de1.jpg";